import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addReferrerAction,
  deleteReferrerAction,
  getAllReferrerAction,
  setAddReferrerResponse,
  setAllReferrerAction,
  setDeleteReferrerResponse,
  updateReferrerAction,
  updateReferrerResponse,
} from "../reducers/referrerSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllReferrerSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/referrers`);
    console.log("plans-", res);
    if (res?.success) {
      yield put(setAllReferrerAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* addReferrerSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/referrers"
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddReferrerResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddReferrerResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateReferrerSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const {
        id,
      label,
      contact_name,
      type,
      strip_token_id,
      id_string,
      api_active,
      api_key,
      api_site,
      save_to,
      managed_by,
      db_name,
      break_point_1,
      break_point_2,
      break_point_3,
      break_point_4,
      break_point_5,
      break_point_6,
      break_point_7,
      break_point_8,
      comment_1,
      comment_2,
      comment_3,
      comment_4,
      comment_5,
      comment_6,
      comment_7,
      comment_8,
      comment_9,
      created_at,
      updated_at,
      is_deleted,
      created_by,
      updated_by,
      ...newPayload
    } = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      { payload: newPayload },
      "put",
      `client/referrers/${id}`
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updateReferrerResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updateReferrerResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteReferrerSaga(payload: { payload: any }): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    // const {id} = payload;
    console.log("payload", payload);
    const { id, status, created_at, updated_at, ...newPayload } =
      payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/referrers/${id}`
    );
    console.log("changePassword-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteReferrerResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteReferrerResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchReferrer() {
  yield takeLatest<any>(getAllReferrerAction, getAllReferrerSaga);
  yield takeLatest<any>(addReferrerAction, addReferrerSaga);
  yield takeLatest<any>(updateReferrerAction, updateReferrerSaga);
  yield takeLatest<any>(deleteReferrerAction, deleteReferrerSaga);
}
